const NUU_COOKIE_CLIENT_ID = 'x_nuuly_clientId';

module.exports = {
    NUU_COOKIE_CLIENT_ID,
};
